module.exports = __webpack_public_path__ + "sounds/ec6be5f2d7c44fb4108673f2d2b6f101.mp3";